import classnames from 'clsx'
import type { FC } from 'react'

import MountPoints from 'shared/utils/mountPoints'
import algoliaUserService from 'views/assets/scripts/services/storage/AlgoliaUserService'

const QuerySuggestionsList: FC<{
  querySuggestions: string[]
  focusedSuggestionIndex: number
  mountPoints: MountPoints
}> = ({ querySuggestions, mountPoints, focusedSuggestionIndex }) => {
  return (
    <>
      {querySuggestions.length > 0 && (
        <>
          {querySuggestions.map((querySuggestion, index) => (
            <li
              key={querySuggestion}
              className={classnames(
                'o-SearchBox__search-suggest u-padding-xx-small--bottom'
              )}
            >
              <a
                href={mountPoints.getSearch({
                  internal: true,
                  banner: false,
                  query: querySuggestion,
                  userToken: algoliaUserService.getToken(),
                  trackingData: {
                    eventName: 'click on query in after-query-suggest',
                    eventType: 'click',
                    position: String(index + 1),
                    objectIDs: undefined,
                    query: undefined,
                    queryID: undefined,
                  },
                })}
                className={classnames(
                  'o-SearchBox__search-suggest__query-suggestion',
                  {
                    'o-SearchBox__search-suggest__query-suggestion--focused':
                      focusedSuggestionIndex ===
                      querySuggestions.indexOf(querySuggestion),
                  }
                )}
                data-clientside-hook="searchBox_autoSuggest_querySuggestion"
              >
                {querySuggestion}
              </a>
            </li>
          ))}
        </>
      )}
    </>
  )
}

export default QuerySuggestionsList
